import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { Drawer, IconButton } from 'seagull';
import { Menu24 } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import HomeSidebar from "../HomeSidebar/HomeSidebar";
import styles from "./MobileTopBar.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const getMobileTopBarTID = () => getTestIds();
export function MobileTopBar() {
  const {
    MobileTopBarTID
  } = getMobileTopBarTID();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.root,
    "data-testid": MobileTopBarTID.Root(),
    children: [/*#__PURE__*/_jsx(IconButton, {
      "data-testid": MobileTopBarTID.MenuButton(),
      onClick: () => setIsMenuOpen(true),
      children: /*#__PURE__*/_jsx(Menu24, {})
    }), /*#__PURE__*/_jsx(Drawer, {
      "data-testid": MobileTopBarTID.Drawer(),
      anchor: "left",
      open: isMenuOpen,
      onClose: () => setIsMenuOpen(false),
      onCloseButtonClick: () => setIsMenuOpen(false),
      minWidth: 200,
      children: /*#__PURE__*/_jsx("div", {
        className: styles.drawer,
        onClick: e => e.stopPropagation(),
        children: /*#__PURE__*/_jsx(HomeSidebar, {})
      })
    })]
  });
}